// src/components/Fuß/AGB.js

import React from 'react';
import './AGB.css';

function AGB() {
  return (
    <div className="agb-container">
      <h1 className="agb-title">Allgemeine Geschäftsbedingungen (AGBs)</h1>
      <p className="agb-subtitle">
        der prosperly GmbH
        <br />
        Stand: August 2024
      </p>

      {/* 1. Angebot und Vertragsschluss */}
      <div className="agb-section">
        <h2>1. Angebot und Vertragsschluss</h2>
        <p>
          Die vom Besteller unterzeichnete Bestellung ist ein bindendes Angebot. Wir können
          dieses Angebot innerhalb von zwei Wochen durch Zusendung einer
          Auftragsbestätigung annehmen oder innerhalb dieser Frist die bestellte
          Dienstleistung zur Verfügung stellen. Es besteht ein beidseitiges Widerrufsrecht
          von 14 Tagen (inklusive Wochenende) nach beidseitigen Unterschriften für den
          Verwaltervertrag.
        </p>
      </div>

      {/* 2. Überlassene Unterlagen */}
      <div className="agb-section">
        <h2>2. Überlassene Unterlagen</h2>
        <p>
          Unterlagen – auch in elektronischer Form –, wie z.B. Kalkulationen, Zeichnungen
          etc., behalten wir uns das Eigentums- und Urheberrecht vor. Diese Unterlagen
          dürfen Dritten nicht zugänglich gemacht werden, es sei denn, wir erteilen dem
          Besteller unsere ausdrückliche schriftliche Zustimmung. Soweit wir das Angebot des
          Bestellers nicht innerhalb der Frist von Ziffer 1 annehmen, sind diese Unterlagen
          uns unverzüglich zurückzusenden.
        </p>
      </div>

      {/* 3. Preise und Zahlung */}
      <div className="agb-section">
        <h2>3. Preise und Zahlung</h2>
        <p>
          Unsere Preise im Vertrag sind jeweils in Netto und Brutto angegeben. Die
          jeweiligen Mehrwertsteuersätze sind entsprechend anzuwenden. Die Zahlung des
          Bestellers hat in Brutto zu erfolgen.
          <br />
          <br />
          Die Zahlung des Abonnements (Kaufpreis) hat ausschließlich auf das umseitig
          genannte Konto zu erfolgen. Der Abzug von Skonto ist nur bei schriftlicher
          besonderer Vereinbarung zulässig.
          <br />
          <br />
          Sofern nichts anderes vereinbart wird, ist das Abonnement bis zum jeweils dritten
          Werktag des Monats fällig. Verzugszinsen werden in Höhe von 5 % über dem jeweiligen
          Basiszinssatz p.a. (gem. Bundesbank Basiszinssatz) berechnet. Die Geltendmachung
          eines höheren Verzugsschadens bleibt vorbehalten. Für den Fall, dass wir einen
          höheren Verzugsschaden geltend machen, hat der Besteller die Möglichkeit, uns
          nachzuweisen, dass der geltend gemachte Verzugsschaden überhaupt nicht oder in
          zumindest wesentlich niedrigerer Höhe angefallen ist.
        </p>
      </div>

      {/* 4. Aufrechnung und Zurückbehaltungsrechte */}
      <div className="agb-section">
        <h2>4. Aufrechnung und Zurückbehaltungsrechte</h2>
        <p>
          Dem Besteller steht das Recht zur Aufrechnung nur zu, wenn seine Forderungen
          rechtskräftig festgestellt oder unbestritten sind. Zur Aufrechnung gegen unsere
          Ansprüche ist der Besteller auch berechtigt, wenn er Mängelrügen oder
          Gegenansprüche aus demselben Kaufvertrag geltend macht. Zur Ausübung eines
          Zurückbehaltungsrechts ist der Besteller nur insoweit befugt, als sein
          Gegenanspruch auf dem gleichen Vertragsverhältnis beruht.
        </p>
      </div>

      {/* 5. Dienstleistungsbeginn */}
      <div className="agb-section">
        <h2>5. Dienstleistungsbeginn</h2>
        <p>
          <strong>5.1.</strong> Soweit kein ausdrücklich verbindlicher
          Dienstleistungsbeginn vereinbart wurde, sind unsere Dienstleistungstermine bzw.
          Dienstleistungsfristen unserer Dienstleistungen ausschließlich unverbindliche
          Angaben. Der Beginn der von uns angegebenen Dienstleistungszeit setzt die
          rechtzeitige und ordnungsgemäße Erfüllung der Verpflichtungen des Bestellers
          voraus. Die Einrede des nicht erfüllten Vertrages bleibt vorbehalten.
        </p>
        <p>
          <strong>5.2.</strong> Der Besteller kann 4 Wochen nach Überschreitung eines
          unverbindlichen Dienstleistungsbeginns uns in Textform auffordern, binnen einer
          angemessenen Frist zu starten. Sollten wir einen ausdrücklichen Beginn der
          Dienstleistung schuldhaft nicht einhalten oder wenn wir aus anderem Grund in
          Verzug geraten, so muss der Besteller uns eine angemessene Nachfrist zur Bewirkung
          der Leistung setzen. Wenn wir die Nachfrist fruchtlos verstreichen lassen, so ist
          der Besteller berechtigt, vom Verwaltervertrag zurückzutreten.
        </p>
        <p>
          <strong>5.3.</strong> Kommt der Besteller in Annahmeverzug oder verletzt er
          schuldhaft sonstige Mitwirkungspflichten, so sind wir berechtigt, den uns
          hierdurch entstehenden Schaden, einschließlich etwaiger Mehraufwendungen, ersetzt
          zu verlangen. Weitergehende Ansprüche bleiben vorbehalten. Dem Besteller bleibt
          seinerseits vorbehalten nachzuweisen, dass ein Schaden in der verlangten Höhe
          überhaupt nicht oder zumindest wesentlich niedriger entstanden ist. Die Gefahr
          eines zufälligen Untergangs oder einer zufälligen Verschlechterung der
          Dienstleistung geht in dem Zeitpunkt auf den Besteller über, in dem dieser in
          Annahme- oder Schuldnerverzug gerät.
        </p>
        <p>
          <strong>5.4.</strong> Weitere gesetzliche Ansprüche und Rechte des Bestellers
          wegen eines Dienstleistungsverzuges bleiben unberührt.
        </p>
      </div>

      {/* 6. Eigentumsvorbehalt */}
      <div className="agb-section">
        <h2>6. Eigentumsvorbehalt</h2>
        <p>
          <strong>6.1.</strong> Wir behalten uns das Eigentum an den erbrachten
          Dienstleistungen sowie den daraus resultierenden Erzeugnissen bis zur
          vollständigen Zahlung sämtlicher Forderungen aus dem Liefervertrag vor.
        </p>
        <p>
          <strong>6.2.</strong> Bis zum Vertragsabschluss ist der Besteller für die
          Verwaltung sowie für die Erbringung der objektbezogenen Dienstleistungen
          verantwortlich und kann uns nicht für Mängel oder unzureichende Administration
          belangen. Insbesondere ist er verpflichtet, das Objekt auf eigene Kosten gegen
          Diebstahl-, Feuer- und Wasserschäden ausreichend zum Neuwert zu versichern. Müssen
          Wartungs- und Inspektionsarbeiten durchgeführt werden, hat der Besteller diese auf
          eigene Kosten rechtzeitig auszuführen. Solange der Vertragsabschluss sowie
          rechtzeitige Zahlung noch nicht vollzogen ist, hat uns der Besteller unverzüglich
          in Textform zu benachrichtigen, wenn das zu verwaltende Objekt gepfändet oder
          sonstigen Eingriffen Dritter ausgesetzt ist. Soweit der Dritte nicht in der Lage
          ist, uns die gerichtlichen und außergerichtlichen Kosten einer Klage gemäß § 771
          ZPO zu erstatten, haftet der Besteller für den uns entstandenen Ausfall.
        </p>
        <p>
          <strong>6.3.</strong> Wir verpflichten uns, die uns zustehenden Sicherheiten auf
          Verlangen des Bestellers freizugeben, soweit ihr Wert die zu sichernden Forderungen
          um mehr als 20% übersteigt.
        </p>
      </div>

      {/* 7. Gewährleistung und Mängelrüge */}
      <div className="agb-section">
        <h2>7. Gewährleistung und Mängelrüge</h2>

        {/* 7.1 */}
        <p>
          <strong>7.1.</strong> Soweit die in unseren Prospekten, Anzeigen und sonstigen
          Angebotsunterlagen enthaltenen Angaben nicht von uns ausdrücklich als verbindlich
          bezeichnet worden sind, sind die dort enthaltenen Abbildungen oder Zeichnungen nur
          annähernd maßgebend.
        </p>

        {/* 7.2 */}
        <p>
          <strong>7.2.</strong> Soweit die erbrachte Dienstleistung nicht den nachfolgend
          aufgeführten subjektiven Anforderungen, den objektiven Anforderungen oder den
          vertraglich vereinbarten Anforderungen entspricht, so sind wir zur Nacherfüllung
          verpflichtet. Dies gilt nicht, wenn wir aufgrund der gesetzlichen Regelungen zur
          Verweigerung der Nacherfüllung berechtigt sind.
        </p>
        <p>
          Die Sache entspricht nicht den subjektiven Anforderungen, wenn sie
          <br />
          a) nicht die zwischen dem Besteller und uns vereinbarte Beschaffenheit aufweist,
          <br />
          b) sich nicht für die nach unserem Vertrag vorausgesetzte Verwendung eignet und
          <br />
          c) nicht mit den vereinbarten Anleitungen übergeben wird.
        </p>
        <p>
          Soweit nicht zwischen dem Besteller und uns unter Beachtung der geltenden
          Informations- und Formvorschriften etwas anderes vereinbart wurde, entspricht die
          Sache nicht den objektiven Anforderungen, wenn sie
          <br />
          d) sich nicht für die gewöhnliche Verwendung eignet,
          <br />
          e) nicht die Beschaffenheit aufweist, die bei Sachen derselben Art üblich ist und
          die der Besteller erwarten kann unter Berücksichtigung der Art der Sache und der
          öffentlichen Äußerungen, die von uns oder einem anderen Glied der Vertragskette
          oder in deren Auftrag, insbesondere in der Werbung oder in vertraglichen Dokumenten
          sowie Schriftverkehr, abgegeben wurden,
          <br />
          f) nicht der Beschaffenheit einer Probe oder eines Musters entspricht, die oder
          das wir dem Besteller vor Vertragsschluss zur Verfügung gestellt haben und
          <br />
          g) nicht mit anderen Anleitungen übergeben wird, deren Erhalt der Besteller
          erwarten kann.
        </p>
        <p>
          Eine wirksame anderweitige Vereinbarung zwischen dem Besteller und uns über die
          objektiven Anforderungen der Sache setzt voraus, dass der Besteller vor Abgabe
          seiner Vertragserklärung eigens davon in Kenntnis gesetzt wurde, dass ein
          bestimmtes Merkmal der Dienstleistung von den objektiven Anforderungen abweicht,
          und die Abweichung in diesem Sinne im Vertrag ausdrücklich und gesondert
          vereinbart wurde.
        </p>

        {/* 7.3 */}
        <p>
          <strong>7.3.</strong> Der Besteller hat zunächst die Wahl, ob die Nacherfüllung
          durch Nachbesserung erfolgen soll. Wir sind jedoch berechtigt, die vom Besteller
          gewählte Art der Nacherfüllung zu verweigern, wenn sie nur mit
          unverhältnismäßigen Kosten möglich ist und die andere Art der Nacherfüllung ohne
          erhebliche Nachteile für den Besteller bleibt. Während der Nacherfüllung sind die
          Herabsetzung des Kaufpreises oder der Rücktritt vom Vertrag durch den Besteller
          ausgeschlossen. Eine Nachbesserung gilt mit dem erfolglosen zweiten Versuch als
          fehlgeschlagen, wenn sich nicht insbesondere aus der Art der Sache oder des Mangels
          oder den sonstigen Umständen etwas anderes ergibt. Ist die Nacherfüllung
          fehlgeschlagen oder haben wir die Nacherfüllung insgesamt verweigert, kann der
          Besteller nach seiner Wahl Herabsetzung des Kaufpreises (Minderung) verlangen oder
          den Rücktritt vom Vertrag erklären. Der Besteller hat uns keine Frist zur
          Nacherfüllung zu setzen. Sobald der Besteller uns über den Mangel unterrichtet hat,
          eine angemessene Frist abgelaufen ist und bis dahin keine Nacherfüllung erfolgt
          ist, ist der Besteller ebenfalls zum Rücktritt oder zur Minderung berechtigt.
        </p>

        {/* 7.4 */}
        <p>
          <strong>7.4.</strong> Schadensersatzansprüche zu den nachfolgenden Bedingungen
          wegen des Mangels kann der Besteller erst geltend machen, wenn die Nacherfüllung
          fehlgeschlagen ist oder wir die Nacherfüllung verweigert haben. Der Besteller hat
          uns keine Frist zur Nacherfüllung zu setzen. Sobald der Besteller uns über den
          Mangel unterrichtet hat, eine angemessene Frist abgelaufen ist und bis dahin keine
          Nacherfüllung erfolgt ist, ist der Besteller ebenfalls zur Geltendmachung von
          Schadensersatzansprüchen berechtigt. Das Recht des Bestellers zur Geltendmachung
          von weitergehenden Schadensersatzansprüchen zu den nachfolgenden Bedingungen
          bleibt davon unberührt.
        </p>

        {/* 7.5 */}
        <p>
          <strong>7.5.</strong> Das Recht des Bestellers zur Geltendmachung von
          weitergehenden Schadensersatzansprüchen zu den nachfolgenden Bedingungen bleibt
          davon unberührt.
        </p>

        {/* 7.6 */}
        <p>
          <strong>7.6.</strong> Wir haften unbeschadet vorstehender Regelungen und der
          nachfolgenden Haftungsbeschränkungen uneingeschränkt für Schäden an Leben, Körper
          und Gesundheit, die auf einer fahrlässigen oder vorsätzlichen Pflichtverletzung
          unserer gesetzlichen Vertreter oder unserer Erfüllungsgehilfen beruhen, sowie für
          Schäden, die von der Haftung nach dem Produkthaftungsgesetz umfasst werden, sowie
          für alle Schäden, die auf vorsätzlichen oder grob fahrlässigen
          Vertragsverletzungen sowie Arglist unserer gesetzlichen Vertreter oder unserer
          Erfüllungsgehilfen beruhen. Insofern wir bezüglich der Dienstleistung oder Teile
          derselben eine Beschaffenheitsgarantie abgegeben haben, haften wir auch im Rahmen
          dieser Garantie. Für Schäden, die auf dem Fehlen der garantierten Beschaffenheit
          beruhen, aber nicht unmittelbar an der Dienstleistung eintreten, haften wir
          allerdings nur dann, wenn das Risiko eines solchen Schadens ersichtlich von der
          Beschaffenheitsgarantie erfasst ist.
        </p>

        {/* 7.7 */}
        <p>
          <strong>7.7.</strong> Wir haften auch für Schäden, die durch einfache
          Fahrlässigkeit verursacht werden, soweit diese Fahrlässigkeit die Verletzung
          solcher Vertragspflichten betrifft, deren Einhaltung für die Erreichung des
          Vertragszwecks von besonderer Bedeutung ist (Kardinalpflichten). Wir haften jedoch
          nur, soweit die Schäden in typischer Weise mit dem Vertrag verbunden und
          vorhersehbar sind. Bei einfachen fahrlässigen Verletzungen nicht
          vertragswesentlicher Nebenpflichten haften wir im Übrigen nicht. Die in den Sätzen
          1 – 3 enthaltenen Haftungsbeschränkungen gelten auch, soweit die Haftung für die
          gesetzlichen Vertreter, leitenden Angestellten und sonstigen Erfüllungsgehilfen
          betroffen ist.
        </p>

        {/* 7.8 */}
        <p>
          <strong>7.8.</strong> Eine weitergehende Haftung ist ohne Rücksicht auf die
          Rechtsnatur des geltend gemachten Anspruchs ausgeschlossen. Soweit unsere Haftung
          ausgeschlossen oder beschränkt ist, gilt dies auch für die persönliche Haftung
          unserer Angestellten, Arbeitnehmer, Mitarbeiter, Vertreter und
          Erfüllungsgehilfen.
        </p>

        {/* 7.9 */}
        <p>
          <strong>7.9.</strong> Die Gewährleistungsfrist beträgt grundsätzlich 2 Jahre,
          gerechnet ab Gefahrübergang. Hat sich ein Mangel innerhalb der Verjährungsfrist
          gezeigt, so tritt die Verjährung nicht vor dem Ablauf von vier Monaten nach dem
          Zeitpunkt ein, in dem sich der Mangel erstmals gezeigt hat. Hat der Besteller zur
          Nacherfüllung oder zur Erfüllung von Ansprüchen aus einer Garantie die
          Dienstleistung an uns oder auf unsere Veranlassung einem Dritten übergeben, so
          tritt die Verjährung von Ansprüchen wegen des geltend gemachten Mangels nicht vor
          Ablauf von zwei Monaten nach dem Zeitpunkt ein, in dem die nachgebesserte oder
          ersetzte Dienstleistung dem Besteller übergeben wurde. Diese Frist gilt auch für
          Ansprüche auf Ersatz von Mangelfolgeschäden, soweit keine Ansprüche aus unerlaubter
          Handlung geltend gemacht werden.
        </p>
      </div>

      {/* 8. Sonstiges */}
      <div className="agb-section">
        <h2>8. Sonstiges</h2>
        <p>
          <strong>8.1.</strong> Dieser Vertrag und die gesamten Rechtsbeziehungen der
          Parteien unterliegen dem Recht der Bundesrepublik Deutschland unter Ausschluss des
          UN-Kaufrechts (CISG).
        </p>
        <p>
          <strong>8.2.</strong> Sollten einzelne Bestimmungen dieses Vertrages unwirksam
          sein oder werden oder eine Lücke enthalten, so bleiben die übrigen Bestimmungen
          hiervon unberührt.
        </p>
      </div>
    </div>
  );
}

export default AGB;
